<template>
  <div>
    <h2 class="text-center bordered-box-header">{{firstName}} {{lastName}}</h2>
    <b-card no-body>
      <b-tabs card>
        <b-tab title="Konto kursanta">
          <user :id="id" />
        </b-tab>
        <b-tab title="Kursy">
          <courses :id="id" />
        </b-tab>
        <b-tab title="Makrocykle">
          <cycles :id="id" />
        </b-tab>
        <b-tab title="Statystyki">
          <statistics :id="id" />
        </b-tab>
        <b-tab title="Płatności">
          <payments :id="id" />
        </b-tab>
        <b-tab title="Kalendarz">
          <calendar :id="id" />
        </b-tab>
        <!-- <b-tab title="Urlopy">
          <freedays :id="id" />
        </b-tab>-->
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import user from "./components/DetailsUser";
import courses from "./components/DetailsCourses";
import cycles from "./components/DetailsCycles";
import statistics from "./components/DetailsStatistics";
import payments from "./components/DetailsPayments";
// import freedays from "./components/DetailsFreeDays";
import calendar from "./../DetailsCalendar";
import { axios, eventBus } from "@/_infrastructure";

export default {
  data() {
    return {
      firstName: null,
      lastName: null
    };
  },
  mounted() {
    if (this.id) {
      axios
        .get("/students/details", {
          params: {
            id: this.id
          }
        })
        .then(response => {
          var result = response.data;

          this.firstName = result.firstName;
          this.lastName = result.lastName;
        })
        .catch(error => eventBus.$emit("unhandled-error", error));
    }
  },
  props: ["id"],
  components: {
    user,
    courses,
    cycles,
    statistics,
    payments,
    calendar
    //freedays
  }
};
</script>

<style lang="scss" scoped>
h2.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-bottom: 0px;
}
.tabs /deep/ .tab-pane:focus {
  outline: none;
}
</style>